import { gql } from '@apollo/client'

export const InviteByEmail = gql`
    mutation InviteByEmail($roomId: ID!, $email: String!) {
        inviteByEmail(roomId: $roomId, email: $email)
    }
`

export default InviteByEmail
